<template replaceable part="pagination">
  <!-- <nav v-show="!(hideSinglePage && totalPages === 1)" class="smart-pagination pagination"> -->
  <div class="navContainer">
    <div class="resultsCount text-sm font-medium">
      Showing {{ resultsMin }} - {{ resultsMax }} of {{ count }}
    </div>
    <nav
      v-show="!(hideSinglePage && totalPages < 2)"
      class="relative z-0 inline-flex mx-auto"
      aria-label="Pagination"
    >
      <a
        href="javascript:void(0)"
        @click="firstPage()"
        :class="{ disabled: currentPage === 1 }"
        v-if="boundaryLinks"
        class="relative inline-flex items-center text-sm font-medium"
      >
        <span class="sr-only">First</span>
        <!-- Heroicon name: chevron-left -->
        <svg
          class="h-5 w-5"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
          aria-hidden="true"
          style="margin-right:-14px;"
        >
          <path
            fill-rule="evenodd"
            d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
            clip-rule="evenodd"
          />
        </svg>
        <svg
          class="h-5 w-5"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
          aria-hidden="true"
        >
          <path
            fill-rule="evenodd"
            d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
            clip-rule="evenodd"
          />
        </svg>
        First
      </a>

      <a
        href="javascript:void(0)"
        @click="previousPage()"
        :class="{ disabled: currentPage === 1 }"
        v-if="directionLinks"
        class="relative inline-flex items-center text-sm font-medium"
        style="padding-left:3px; margin-left: 3px;"
      >
        <span class="sr-only">Previous</span>
        <!-- Heroicon name: chevron-left -->
        <svg
          class="h-5 w-5"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
          aria-hidden="true"
        >
          <path
            fill-rule="evenodd"
            d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
            clip-rule="evenodd"
          />
        </svg>
        Prev
      </a>

      <a
        href="javascript:void(0)"
        @click="selectPage(page.value)"
        v-for="page in displayPages"
        :class="{ active: currentPage === page.value }"
        :key="page.value"
        class="relative inline-flex items-center ml-2 text-sm font-medium text-gray-700"
      >
        {{ page.title }}
      </a>

      <a
        href="javascript:void(0)"
        @click="nextPage()"
        :class="{ disabled: currentPage === totalPages }"
        v-if="directionLinks"
        class="relative inline-flex items-center text-sm font-medium"
        style="padding-right:3px;"
      >
        <span class="sr-only">Next</span>
        <!-- Heroicon name: chevron-right -->
        Next
        <svg
          class="h-5 w-5"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
          aria-hidden="true"
        >
          <path
            fill-rule="evenodd"
            d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
            clip-rule="evenodd"
          />
        </svg>
      </a>

      <a
        href="javascript:void(0)"
        @click="lastPage()"
        :class="{ disabled: currentPage === totalPages }"
        v-if="boundaryLinks"
        class="relative inline-flex items-center text-sm font-medium"
        style="padding-right:3px; margin-left: 3px;"
      >
        <span class="sr-only">Last</span>
        <!-- Heroicon name: chevron-left -->
        Last
        <svg
          class="h-5 w-5"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
          aria-hidden="true"
        >
          <path
            fill-rule="evenodd"
            d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
            clip-rule="evenodd"
          />
        </svg>
        <svg
          class="h-5 w-5"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
          aria-hidden="true"
          style="margin-left:-14px;"
        >
          <path
            fill-rule="evenodd"
            d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
            clip-rule="evenodd"
          />
        </svg>
      </a>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'SmartPagination',
  props: {
    pageSize: {
      required: true,
      type: Number,
    },
    currentPage: {
      required: true,
      type: Number,
    },
    count: {
      required: false,
      type: Number,
    },
    hideSinglePage: {
      required: false,
      type: Boolean,
      default: true,
    },
    maxPageLinks: {
      required: false,
      type: Number,
      default: 10,
    },
    boundaryLinks: {
      required: false,
      type: Boolean,
      default: false,
    },
    firstText: {
      required: false,
      type: String,
      default: 'First',
    },
    lastText: {
      required: false,
      type: String,
      default: 'Last',
    },
    directionLinks: {
      required: false,
      type: Boolean,
      default: true,
    },
  },
  computed: {
    displayPages() {
      if (isNaN(this.maxPageLinks) || this.maxPageLinks <= 0) {
        return this.displayAllPages();
      } else {
        return this.limitVisiblePages();
      }
    },
    totalPages() {
      return Math.ceil(this.count / this.pageSize);
    },
    resultsMin() {
      if (this.count > 0) {
        return this.currentPage === 1
          ? 1
          : (this.currentPage - 1) * this.pageSize + 1;
      } else {
        return 0;
      }
    },
    resultsMax() {
      if (this.currentPage && this.pageSize) {
        return Math.min(this.resultsMin + this.pageSize - 1, this.count);
      } else {
        return 0;
      }
    },
  },
  methods: {
    displayAllPages() {
      const displayPages = [];

      for (let i = 1; i <= this.totalPages; i++) {
        displayPages.push({
          title: i.toString(),
          value: i,
        });
      }
      return displayPages;
    },
    limitVisiblePages() {
      const displayPages = [];

      let start = Math.max(1, this.currentPage - 4);
      let end = Math.min(this.totalPages, this.currentPage + 4);

      if (start === 1) {
        end = 9;
      } else if (end === this.totalPages) {
        start = Math.max(1, this.totalPages - 8);
      }

      for (let i = start; i <= end; i++) {
        if (i > this.totalPages) {
          break;
        }

        displayPages.push({
          title: i.toString(),
          value: i,
        });
      }

      return displayPages;
    },
    selectPage(page) {
      if (page < 1 || page > this.totalPages || page === this.currentPage) {
        return;
      }

      this.$emit('update:currentPage', page);
      window.scrollTo(0, 0);
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        window.scrollTo(0, 0);
        this.$emit('update:currentPage', this.currentPage + 1);
      }
    },
    previousPage() {
      if (this.currentPage > 1) {
        window.scrollTo(0, 0);
        this.$emit('update:currentPage', this.currentPage - 1);
      }
    },
    firstPage() {
      window.scrollTo(0, 0);
      this.$emit('update:currentPage', 1);
    },
    lastPage() {
      window.scrollTo(0, 0);
      this.$emit('update:currentPage', this.totalPages);
    },
  },
};
</script>

<style scoped>
.navContainer {
  padding-bottom: 6px;
  min-height: 35px;
}
.navContainer nav {
  float: right;
}
.navContainer nav::after {
  clear: both;
}
.disabled svg {
  color: grey;
}

.disabled a {
  cursor: not-allowed;
}
.text-sm {
  line-height: 1rem;
}
nav > a {
  margin-left: 0.75rem;
  border-radius: 0.1875rem;
  transition: all 0.15s ease-out;
  padding: 3px 7px;
  color: #4d48e8;
}
nav > a:focus {
  outline: none;
}
nav > a:first-child {
  margin-left: 0;
}
nav > a.active {
  background: #f0effa;
  border: 1px solid #8d8ae7;
}
nav > a:hover {
  background: #f0effa;
}
nav > a.disabled:hover {
  background: none;
}
.disabled {
  cursor: not-allowed;
  color: #666;
}
.resultsCount {
  float: left;
  color: #666;
}
</style>
